export default __webpack_public_path__ + "3eff5978735b9ece505f43ab8a564b6e.png";